<template>
    <drag-modal :visible="$store.state.dislog.CasePopUp" @cancel="close" title='修改案件信息' width='660px'>
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
            <a-form-model-item label="案由：" prop="cause_reason_id">
                <!-- <a-select show-search v-model="form.cause_reason_id" placeholder="请选择案由"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                    <a-select-option v-for="d in cause_reason" :key="d.id">
                        {{ d.title }}
                    </a-select-option>
                </a-select> -->
                <a-tree-select v-model="form.cause_reason_id" show-search style="width: 100%"
                    :dropdown-style="{ maxHeight: '400px', maxWidth: '200px', overflow: 'auto' }" placeholder="请选择案由"
                    allow-clear :treeDefaultExpandAll="false" :tree-data="cause_reason" :replace-fields="replaceFields"
                    tree-node-filter-prop="title" :treeDefaultExpandedKeys="expandedKeys">
                    <template slot="treeNodeLabel" slot-scope="{ node }">
                        <a-tooltip overlayClassName="custom-tip" :title="node.title" placement="top"
                            :get-popup-container="() => document.body">
                            <div class="tree-node-text">{{ node.title }}</div>
                        </a-tooltip>
                    </template>
                </a-tree-select>
            </a-form-model-item>
            <a-form-model-item label="法院地区：" prop="court">
                <a-cascader :options="options" placeholder="请选择" change-on-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model="form.court" @change="
                        seachCourtList(form.court)
                    form.court_id = null
                        " />
            </a-form-model-item>
            <a-form-model-item label="管辖法院" prop="court_id">
                <a-select show-search v-model="form.court_id" placeholder="请选择法院"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
                    :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                    :not-found-content="null">
                    <a-select-option v-for="d in courtList" :key="d.id">
                        <Normap :tit='d.title'>{{ d.title }}</Normap>
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="业务部门：" prop="team_id" v-if="form.accuser_id">
                <a-select show-search v-model="form.team_id" placeholder="请选择业务部门"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                    <a-select-option v-for="(d, num) in teamList" :key="num" :value="d.team.id">
                        {{ d.team.title }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="金融机构：" prop="bank_id">
                <a-select show-search v-model="form.bank_id" placeholder="请选择金融机构"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
                    :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                    :not-found-content="null">
                    <a-select-option v-for="d in bankList" :key="d.id">
                        {{ d.title }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="诉讼完毕：" prop="cause_is_complete">
                <a-select v-model='form.cause_is_complete' placeholder="请选择">
                    <a-select-option :key="1">是</a-select-option>
                    <a-select-option :key="0">否</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="代偿完毕：" prop="is_full_pay">
                <a-select v-model='form.is_full_pay' placeholder="请选择">
                    <a-select-option :key="3">否</a-select-option>
                    <a-select-option :key="2">是</a-select-option>
                    <a-select-option :key="1">不详</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="重审案件" prop="is_retrial">
                <a-select v-model="form.is_retrial" placeholder="请选择">
                    <a-select-option :key="1">是</a-select-option>
                    <a-select-option :key="2">否</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="本金" prop="capital">
                <a-input v-model="form.capital" placeholder="请输入本金" min="1" @change="handleAmountInput"></a-input>
            </a-form-model-item>
            <a-form-model-item label="利息" prop="used_fee">
                <a-input v-model="form.used_fee" placeholder="请输入利息" @change="handleFeeInput"></a-input>
            </a-form-model-item>
            <!-- <a-form-model-item label="本案代偿明细：" prop="compensation">
                <div v-for="(item, index) in form.compensation" :key="index"
                    style="display: flex;position: relative;;margin-bottom: 15px;margin-top: 5px;">
                    <a-input-group style="display: flex;gap: 5px;align-items: center;">
                        <a-date-picker v-model="item.time" placeholder="请选择时间"
                            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                            valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" type="date" style="width: 100%;flex: 1;" />
                        <a-input v-model="item.amount" placeholder="请输入金额" style="flex: 1;border-radius: 4px;" />
                    </a-input-group>
                    <div class="btns">
                        <a-icon type="plus-circle" class="i add" @click='add'
                            v-if='index == 0' style="margin-right:10px;" />
                        <a-icon type="minus-circle" class="i del" @click='del(index)'
                            v-else />
                    </div>
                </div>
            </a-form-model-item> -->
            <a-form-model-item label="本案代偿明细：">
                <div v-for="(item, index) in form.compensation" :key="index" style="display: flex;position: relative;">
                    <a-input-group style="display: flex;gap: 5px;width: 100%;">
                        <a-form-model-item :prop="`compensation.${index}.time`" :rules="timeRules"
                            style="margin-bottom:0;">
                            <a-date-picker v-model="item.time" placeholder="请选择时间"
                                :getPopupContainer="(triggerNode) => triggerNode.parentNode" valueFormat="YYYY-MM-DD"
                                format="YYYY-MM-DD" style="width:100%" />
                        </a-form-model-item>
                        <a-form-model-item :prop="`compensation.${index}.amount`" :rules="amountRules"
                            style="margin-bottom:0;">
                            <a-input v-model="item.amount" placeholder="请输入金额" style="width:100%" />
                        </a-form-model-item>
                    </a-input-group>

                    <div class="btns">
                        <a-icon type="plus-circle" class="i add" @click='add' style="margin-right:10px;"
                            v-if='index == 0' />
                        <a-icon type="minus-circle" class="i del" @click='del(index)' v-else />
                    </div>
                </div>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
                <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
                    <a-button type="primary" style="width:148px;">
                        提交
                    </a-button>
                </a-popconfirm>
                <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;"
                    @click='close'>取消</a-button>
            </a-form-model-item>
        </a-form-model>
    </drag-modal>
</template>
<script>
import city from "@/assets/js/city.json"
import Validator from "@/assets/js/yz.js"
import { accuseList } from "@/server/api"
import { mapGetters } from 'vuex'
import { citySort } from '@/assets/js/unit'
import { getDirectory, bankList, getAccInit } from '@/server/directory'

function isValidDate(date) {
    return date instanceof Date && !isNaN(date.getTime())
}
export default {
    props: {
        cause_reason: Array,
        accuserList: Array,
        i: Object
    },
    name: 'CasePopUp',
    data() {
        return {
            replaceFields: {
                children: 'child',
                title: 'title',
                key: 'id',
                value: 'id'
            },
            data: {
                limit: 50,
                page: 1,
                title: null,
            },
            Validator,
            audit: [],   //在修改中的字段
            options: citySort(city),
            expandedKeys: [-1],
            accuser: [], //原告列表
            list: [
                {
                    id: 1,
                    title: '金融借款'
                }, {
                    id: 2,
                    title: '担保追偿'
                }, {
                    id: 3,
                    title: '融资租赁'
                }
            ],
            rules: {
                cause_reason_id: [{ required: true, message: '请选择', trigger: 'change' }],
                court: [{ required: true, message: '请选择', trigger: 'change' }],
                court_id: [{ required: true, message: '请选择', trigger: 'change' }],
                team_id: [{ required: true, message: '请选择', trigger: 'change' }],
                bank_id: [{ required: true, message: '请选择', trigger: 'change' }],
                capital: [{ required: true, validator: Validator.amount.bind(this), trigger: 'blur' }],
                is_retrial: [{ required: true, message: '请选择是否为重审案件', trigger: 'change' }],
                cause_is_complete: [{ required: true, message: '请选择是否诉讼完毕', trigger: 'change' }],
                is_full_pay: [{ required: true, message: '请选择是否代偿完毕', trigger: 'change' }]
            },
            edit: false,
            form: {
                //    cause_is_complete: 0,
                compensation: [{
                    id: 0,
                    time: '',
                    amount: null
                }],
                is_full_pay: 1,
                accuser_id: null,
                is_role_exact: 1,
                car_type_id: 0,
                court: [],
                no: '',
                is_retrial: null,
                court_id: '',
                cause_reason_id: '',
                team_id: null
                // is_full_pay: '',
                // lawsuit: '',
                // business: '',
                // lawsuitNumber: '',
                // executeNumber: ''
            },
            courtList: [],//法院
            bank: [],//金融机构
            accuserId: null,
            plaintiffs: [],
            bankList: [],
            timeRules: [
                {
                    validator: (rule, value, callback) => {
                        const i = rule.field.split('.')[1]
                        const amount = this.form.compensation[i].amount
                        if ((amount !== null && amount !== '') && !value) {
                            return callback('请选择时间')
                        }
                        callback()
                    },
                    trigger: 'change'
                }
            ],
            amountRules: [
                {
                    validator: (rule, value, callback) => {
                        const i = rule.field.split('.')[1]
                        const time = this.form.compensation[i].time
                        if (time && (value === null || value === '')) {
                            return callback('请填写金额')
                        }
                        callback()
                    },
                    trigger: 'blur'
                }
            ]
        }
    },
    watch: {
        i: {
            handler(newVal) {
                if (newVal.accuser_id) {
                    this.accuserId = newVal.accuser.id
                    this.plaintiffs = newVal.parties.plaintiff.map(ele => ele.id);
                    const compensation = newVal.compensation.length > 0 ? newVal.compensation.map(ele => {
                        return {
                            id: ele.id,
                            time: ele.time,
                            amount: ele.amount / 100
                        }
                    }) : [{ id: 0, time: '', amount: null }]
                    this.form = {
                        accuser_id: newVal.accuser_id,
                        cause_reason_id: newVal.reason && newVal.reason.id,
                        court_id: newVal.courte ? newVal.courte.id : '',
                        bank_id: newVal.bank ? newVal.bank.id : null,
                        team_id: newVal.team_id > 0 ? newVal.team_id : null,
                        court: newVal.courte ? [
                            newVal.courte.province_id,
                            newVal.courte.city_id,
                            newVal.courte.area_id,
                        ]
                            : [110000],
                        capital: newVal.capital > 0 ? newVal.capital / 100 : null,
                        used_fee: newVal.used_fee == 0 ? null : newVal.used_fee / 100,
                        no: newVal.id ? newVal.no : null,
                        compensation: compensation,
                        is_retrial: newVal.is_retrial != 0 ? newVal.is_retrial : 2
                    }
                    this.form.is_full_pay = this.debInfo.is_full_pay
                    this.form.cause_is_complete = this.debInfo.cause_is_complete,
                        this.seachCourtList(this.form.court)
                }

            },
            deep: true,
            immediate: true,
        },
        cause_reason: {
            handler(val) {
                this.handleDisableNode(val)
            },
        }
    },
    created() {
        // this.init(this.$route.params.id)
        setTimeout(() => {
            this.bankList = this.$store.state.Case.bankList

        }, 500)
    },
    computed: {
        ...mapGetters([
            'debInfo',
            'APIKEY'
        ]),
        teamList() {
            if (!this.plaintiffs || this.plaintiffs.length === 0) {
                return null;
            }
            if (!this.accuserList || this.accuserList.length === 0) {
                return null;
            }
            const teams = this.plaintiffs.flatMap(ele => {
                const user = this.accuserList.find(item => item.id === ele);
                return user.team || [];
            });
            return teams
        },
    },
    methods: {
        handleDisableNode(tree) {
            if (!Array.isArray(tree)) return
            tree.forEach(item => {
                // key 对应你的 id 字段
                if (item.id === -1) {
                    item.disabled = true
                }
            })
        },
        handleAmountInput(e) {
            const invalidSymbols = /[^0-9.]/g;
            if (invalidSymbols.test(e.target.value)) {
                this.form.capital = ''
                return;
            } else {
                const value = e.target.value;
                e.target.value = Validator.formatAmount ? Validator.formatAmount(value) : value;
            }
        },
        handleFeeInput(e) {
            const invalidSymbols = /[^0-9.]/g;
            if (invalidSymbols.test(e.target.value)) {
                this.form.used_fee = ''
                return;

            } else {
                const value = e.target.value;
                e.target.value = Validator.formatAmount ? Validator.formatAmount(value) : value;
            }
        },
        leaveAcc() {
            if (!this.form.accuser_id) {
                this.data.title = null
            }
        },
        seachCourtList(val) {
            //搜索法院
            let province_id = val[0],
                city_id = val.length > 1 ? val[1] : '',
                area_id = val.length > 2 ? val[2] : ''
            getDirectory({
                province_id: province_id,
                city_id: city_id,
                area_id: area_id,
            }).then((e) => {
                this.courtList = e.list
            })
        },
        add() {
            this.form.compensation.push({
                id: 0,
                time: '',
                amount: null
            })
        },
        del(index) {
            this.form.compensation.splice(index, 1)
        },
        close() {
            this.$store.dispatch('openkey', { key: 'CasePopUp', by: false })
        },
        isEdit(val) {
            let bool = this.audit.filter(ele => {
                return val.split(",").indexOf(ele.field) >= 0
            }).length > 0 ? true : false;
            return bool
        },
        confirm() {
            this.$refs.forms.validate(valid => {
                if (valid) {
                    let form = JSON.parse(JSON.stringify(this.form));
                    form.capital = (form.capital * 100).toFixed(0)
                    form.used_fee = (form.used_fee * 100).toFixed(0)
                    const validCompensation = form.compensation.filter(item => {
                        const hasTime = !!item.time;
                        const hasAmount = item.amount !== null && item.amount !== '';
                        return hasTime || hasAmount;
                    });
                    if (validCompensation.length === 0) {
                        delete form.compensation;
                    } else {
                        form.compensation = validCompensation.map(item => {
                            const amount = Number(item.amount) || null;
                            return {
                                id: item.id,
                                time: item.time,
                                amount: amount > 0 ? Math.round(amount * 100) : null
                            };
                        });
                    }
                    let id = this.$store.state.cause.id
                    if (id) {
                        form.id = id
                    }
                    this.$Ajax({
                        url: id ? 'v2/cause/edit' : '',
                        data: form,
                        contentType: "application/json",
                        success: (e) => {
                            this.$message.success({ content: '修改成功', key: 'updatable' });
                            this.$store.dispatch('Case/getlist', {
                                debtor_id: this.$route.params.id,
                            })
                            this.$emit('resh', 2)
                            this.reset()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        reset() {
            this.$refs.forms.resetFields();
            this.$store.dispatch('openkey', { key: 'CasePopUp', by: false })
        },
        // init(id) {
        //     this.edit = id ? true : false;
        //     if (id) {
        //         this.$Ajax({
        //             url: 'debtor/info',
        //             type: 'get',
        //             data: { id: id },
        //             success: (res) => {
        //                 let e = res.info;
        //                 this.audit = res.info.audit;
        //                 this.accuser = res.info.accuser || {}
        //                 this.form = {
        //                     accuser_id: e.accuser_id,
        //                     dwell: e.dwell_province ? [e.dwell_province, e.dwell_city, e.dwell_area] : [e.province, e.city, e.area],
        //                     // compensation: isValidDate(new Date(e.compensation)) ? e.compensation : '',
        //                     compensation: [{
        //                         time: '',
        //                         amount: null
        //                     }],
        //                     is_role_exact: e.is_role_exact,
        //                     is_full_pay: e.is_full_pay,
        //                     type: e.type,
        //                     car_type_id: e.car_type_id
        //                 }
        //             }
        //         })
        //     } else {
        //         this.rules.accuser_id = [{ required: true, trigger: 'change', message: '请选择原告' }]
        //     }
        // }
    }
}
</script>
<style lang="less">
.newly .yellow {
    border: 1px solid #ff9800 !important;
    opacity: 1;
    color: #ccc;
    /* border: 0 none; */
    background: none;
    border-radius: 6px;
}
</style>
<style lang="less" scoped>
.newly {
    .form {
        width: 600px;
        margin: 0 auto;
    }

    background: #fff;
    padding: 60px 26px;
}

.btns {
    position: absolute;
    width: 15%;
    max-width: 70px;
    display: flex;
    font-size: 1.25rem;
    justify-content: space-between;
    padding-left: 20px;
    right: -65px;
    top: 5px;

    .i {
        cursor: pointer;
    }

    .add {
        color: #118afc;
    }

    .del {
        color: #f00;
    }
}
</style>
<style>
.ant-select-tree-switcher {
    color: #1890ff !important;
}

.ant-select-tree-switcher:hover {
    color: #096dd9 !important;
}

.anticon {
    font-size: 16px !important;
}
</style>